import { observer } from "mobx-react-lite";
import { Outlet, useLocation, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { useStore } from "../../helpers";
import C3Items from "./c3-items";
import { useTranslation } from "react-i18next";
import "react-dropdown-tree-select/dist/styles.css";
import { useIsMobile } from "../../custom-hooks";
import { FilterButton, ProjectHeader } from "../../components";
import { C3Filters } from "./c3-filters";
import { safe_get } from "../../report-visuals";
import { FTPBreadCrumbs } from "../../components-new";
import { Box } from "@mui/material";
import { ServiceRequestFilterTags } from "./serviceRequestFilterTags";
import { PageShell } from "../../layouts/PageShell";

const C3Home = observer((props: any) => {
    const { c3Store } = useStore();
    const { servicerequestFilter, selected_booths, selected_office_persons } =
        c3Store;
    const isMobile = useIsMobile();
    const [t] = useTranslation("constituency_command_center");
    const { projectid } = useParams();
    const rootStore = useStore();
    const { projectStore } = rootStore;
    const project_name = safe_get(projectStore.activeProject, "name", "");
    const isFilterEmpty = Object.values(servicerequestFilter).every(
        (value) => (Array.isArray(value) && value.length === 0) || value === ""
    );
    const { pathname } = useLocation();
    const showservicereq = pathname.includes("service_request");
    const isHistoricalTab = pathname.includes("historical");

    const crumbs = [
        { name: "DashBoard", href: `/project/${projectid}`, current: true },
        {
            name: "Constituency Command Center",
            href: "/project/" + projectid + "/c3",
            current: true,
        },
    ];

    useEffect(() => {
        //c3Store.setServicerequestFilter({});
        return () => {
            c3Store.update_selected_booths([]);
        };
    }, []);

    // Header actions component
    // const headerActions = (
    //     <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
    //         <FilterButton
    //             filterOnClickHandler={(e) => c3Store.update_c3FilterModal(true)}
    //         />
    //     </Box>
    // );
    const headerActions = !isHistoricalTab ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <FilterButton
                filterOnClickHandler={(e) => c3Store.update_c3FilterModal(true)}
            />
        </Box>
    ) : null;
    return (
        <div className="relative">
            {/* <ProjectHeader /> */}
            <PageShell
                title={project_name || "Constituency Command Center"}
                headerActions={headerActions}
                breadcrumbs={<FTPBreadCrumbs crumbs={crumbs} />}
                contentPadding="px-4"
            >
                {!isFilterEmpty && showservicereq && (
                    <ServiceRequestFilterTags />
                )}

                <div className="flex flex-row px-4">
                    {c3Store.selected_booths.length > 0 && (
                        <div className={"flex flex-col"}>
                            <p className="fp-text text-md mr-r p-2 font-bold">
                                Selected Booths:
                            </p>
                            <div className="flex flex-row flex-wrap">
                                {c3Store.selected_booths.map((booth) => (
                                    <p className="p-2 font-bold">
                                        Booth# {safe_get(booth, "id", booth)},
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="bg-gray-100">
                    <div className="mx-2 flex flex-col gap-3 sm:mx-auto sm:flex-row sm:gap-4">
                        <div className="w-full sm:w-1/5">
                            <C3Items />
                        </div>
                        <div className="w-full overflow-x-hidden bg-white p-4 sm:w-4/5">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </PageShell>

            <C3Filters />
        </div>
    );
});

export default C3Home;
